export { default as About } from './About'
export { default as Welcome } from './Welcome'
export { default as MechanismList } from './MechanismList'
export { default as Services } from './Services'
export { default as Difference } from './Difference'
export { default as HowItWork } from './HowItWork'
export { default as Professionals } from './Professionals'
export { default as Mission } from './Mission'
